//-----------------------------|| DETAILS ||---------------------------------------------------------------
export const SET_DASHBOARD_DETAILS = 'SET_DASHBOARD_DETAILS';
export const CLEAR_DASHBOARD_DETAILS = 'CLEAR_DASHBOARD_DETAILS';
export const DASHBOARD_DETAILS_PENDING = 'DASHBOARD_DETAILS_PENDING';
export const DASHBOARD_DETAILS_ERROR = 'DASHBOARD_DETAILS_ERROR';
export const DASHBOARD_DETAILS_ERROR_CLEAR = 'DASHBOARD_DETAILS_ERROR_CLEAR';

//-----------------------------|| USER DASHBOARD DETAILS ||------------------------------------------------
export const SET_USER_DASHBOARD_DETAILS = 'SET_USER_DASHBOARD_DETAILS';
export const CLEAR_USER_DASHBOARD_DETAILS = 'CLEAR_USER_DASHBOARD_DETAILS';
export const USER_DASHBOARD_DETAILS_PENDING = 'USER_DASHBOARD_DETAILS_PENDING';
export const USER_DASHBOARD_DETAILS_ERROR = 'USER_DASHBOARD_DETAILS_ERROR';
export const USER_DASHBOARD_DETAILS_ERROR_CLEAR = 'USER_DASHBOARD_DETAILS_ERROR_CLEAR';

//-----------------------------|| FIELD SELECT ||----------------------------------------------------------
export const FORM_FIELD_SELECT_DIALOG_OPEN = 'FORM_FIELD_SELECT_DIALOG_OPEN';
export const FORM_FIELD_SELECT_DIALOG_CLOSE = 'FORM_FIELD_SELECT_DIALOG_CLOSE';

//-----------------------------|| GRAPH FILTER ||----------------------------------------------------------
export const DASHBOARD_FILTER_DIALOG_OPEN = 'DASHBOARD_FILTER_DIALOG_OPEN';
export const DASHBOARD_FILTER_DIALOG_CLOSE = 'DASHBOARD_FILTER_DIALOG_CLOSE';
export const SET_DASHBOARD_FILTER_DATA = 'SET_DASHBOARD_FILTER_DATA';

//-----------------------------|| PRIMARY ENTITY GRAPH ||--------------------------------------------------
export const SET_PRIMARY_ENTITY_GRAPH_DETAILS = 'SET_PRIMARY_ENTITY_GRAPH_DETAILS';
export const CLEAR_PRIMARY_ENTITY_GRAPH_DETAILS = 'CLEAR_PRIMARY_ENTITY_GRAPH_DETAILS';
export const PRIMARY_ENTITY_GRAPH_DETAILS_PENDING = 'PRIMARY_ENTITY_GRAPH_DETAILS_PENDING';
export const PRIMARY_ENTITY_GRAPH_DETAILS_ERROR = 'PRIMARY_ENTITY_GRAPH_DETAILS_ERROR';
export const PRIMARY_ENTITY_GRAPH_DETAILS_ERROR_CLEAR = 'PRIMARY_ENTITY_GRAPH_DETAILS_ERROR_CLEAR';

//-----------------------------|| TMLS GRAPH ||------------------------------------------------------------
export const SET_TMLS_GRAPH_DETAILS = 'SET_TMLS_GRAPH_DETAILS';
export const CLEAR_TMLS_GRAPH_DETAILS = 'CLEAR_TMLS_GRAPH_DETAILS';
export const TMLS_GRAPH_DETAILS_PENDING = 'TMLS_GRAPH_DETAILS_PENDING';
export const TMLS_GRAPH_DETAILS_ERROR = 'TMLS_GRAPH_DETAILS_ERROR';
export const TMLS_GRAPH_DETAILS_ERROR_CLEAR = 'TMLS_GRAPH_DETAILS_ERROR_CLEAR';

//-----------------------------|| DYSBACTERIOSIS GRAPH ||--------------------------------------------------
export const SET_DYSBACTERIOSIS_GRAPH_DETAILS = 'SET_DYSBACTERIOSIS_GRAPH_DETAILS';
export const CLEAR_DYSBACTERIOSIS_GRAPH_DETAILS = 'CLEAR_DYSBACTERIOSIS_GRAPH_DETAILS';
export const DYSBACTERIOSIS_GRAPH_DETAILS_PENDING = 'DYSBACTERIOSIS_GRAPH_DETAILS_PENDING';
export const DYSBACTERIOSIS_GRAPH_DETAILS_ERROR = 'DYSBACTERIOSIS_GRAPH_DETAILS_ERROR';
export const DYSBACTERIOSIS_GRAPH_DETAILS_ERROR_CLEAR = 'DYSBACTERIOSIS_GRAPH_DETAILS_ERROR_CLEAR';

//-----------------------------|| CHOOSE GRAPH TYPE||------------------------------------------------------
export const PRIMARY_ENTITY_GRAPH_TYPE = 'PRIMARY_ENTITY_GRAPH_TYPE';
export const TMLS_GRAPH_TYPE = 'TMLS_GRAPH_TYPE';
export const DYSBACTERIOSIS_GRAPH_TYPE = 'DYSBACTERIOSIS_GRAPH_TYPE';


//-----------------------------|| OTHER CONSTANTS ||-------------------------------------------------------

export const GRAPH_TYPE = [
    { label: "Line", value: "line-chart" },
    { label: "Bar", value: "bar-chart" },
]